module.exports = __webpack_public_path__ + "img/77.20d11835.jpg";